// IntradayBidding 画面のページタブ定義 (= design `intraday.html` の `#ecl-page-tabs`)。
//
//   入札追加 (bidCreate) / 板発注 (marketBoard) / 入札履歴 (bidHistory) / 約定履歴 (executionResult)
//
// タブの中のタブ (サブタブ) は置かない (spec intraday-bidding.md 冒頭・AC-BIN-102。
// #9629 の PdM 判断 2026-10-10: 入札履歴には板発注で出した札も入るので、 旧「入札管理」 の
// サブタブから外し、 板発注と約定履歴の間に出す。 「入札管理」 の名前はやめた)。
//
// design は 板発注 / 約定履歴 を独立 HTML ページに分離しているが、 実装側は単一ルート
// (/bidding/intraday) 内のタブで同じ視覚構造を再現する (= ルート分割はしない)。

export type IntradayPageTabKey =
  | 'bidCreate'
  | 'marketBoard'
  | 'bidHistory'
  | 'executionResult'

export type IntradayPageTabDef = {
  key: IntradayPageTabKey
  labelKey: string
}

export const INTRADAY_PAGE_TABS: IntradayPageTabDef[] = [
  { key: 'bidCreate', labelKey: 'page:biddingIntraday.tab.bidCreate' },
  { key: 'marketBoard', labelKey: 'page:biddingIntraday.tab.marketBoard' },
  { key: 'bidHistory', labelKey: 'page:biddingIntraday.tab.bidHistory' },
  {
    key: 'executionResult',
    labelKey: 'page:biddingIntraday.tab.executionResult',
  },
]

export const DEFAULT_INTRADAY_PAGE_TAB: IntradayPageTabKey = 'bidCreate'
